import { CheckoutDataInterface } from './types';

export const initialState: CheckoutDataInterface = {
  paymentMethodSelected: undefined,
  chargesToPaySelected: [],
};
